module.exports = __webpack_public_path__ + "static/media/Technologyicon02.0b95cde6.png";